var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 40C8 34.4772 11.5 29.5 29 30.5",
    stroke: "#008F47",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7343 32.3245L41.6817 32.2355C41.5366 31.9898 41.4625 31.7103 41.4674 31.4267L41.4913 30.0353C41.4962 29.751 41.3429 29.4865 41.0908 29.3445L38.9012 28.111C38.6498 27.9694 38.3396 27.9719 38.0907 28.1177L36.8752 28.8291C36.6268 28.9745 36.3427 29.0513 36.0532 29.0513H35.9478C35.6576 29.0513 35.3729 28.9742 35.1242 28.8282L33.9031 28.1116C33.6533 27.9649 33.3417 27.9627 33.0897 28.1057L30.907 29.3441C30.6562 29.4864 30.5038 29.7502 30.5086 30.0337L30.5326 31.4267C30.5375 31.7103 30.4634 31.9898 30.3183 32.2355L30.2664 32.3233C30.1211 32.5691 29.9103 32.7716 29.6564 32.9091L28.4123 33.5831C28.1573 33.7212 27.9993 33.984 28 34.269L28.0057 36.7342C28.0064 37.0175 28.1637 37.2783 28.4169 37.416L29.655 38.0893C29.9098 38.2279 30.121 38.4319 30.2658 38.6792L30.3215 38.7742C30.4645 39.0186 30.5375 39.2962 30.5326 39.5777L30.5087 40.9646C30.5038 41.249 30.6571 41.5135 30.9092 41.6555L33.0988 42.889C33.3502 43.0306 33.6604 43.0281 33.9093 42.8823L35.1247 42.1709C35.3732 42.0255 35.6573 41.9487 35.9468 41.9487H36.0522C36.3424 41.9487 36.6271 42.0258 36.8758 42.1718L38.0969 42.8884C38.3467 43.0351 38.6583 43.0373 38.9103 42.8943L41.093 41.6559C41.3438 41.5136 41.4962 41.2498 41.4914 40.9663L41.4674 39.5733C41.4625 39.2897 41.5366 39.0102 41.6817 38.7645L41.7336 38.6767C41.8789 38.4309 42.0897 38.2284 42.3436 38.0909L43.5877 37.4169C43.8427 37.2788 44.0007 37.016 44 36.731L43.9943 34.2658C43.9936 33.9825 43.8363 33.7217 43.5831 33.584L42.3421 32.9091C42.0891 32.7715 41.8791 32.5695 41.7343 32.3245Z",
    stroke: "#008F47",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36 39C37.6569 39 39 37.6569 39 36C39 34.3431 37.6569 33 36 33C34.3431 33 33 34.3431 33 36C33 37.6569 34.3431 39 36 39Z",
    stroke: "#008F47",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 26C28.9706 26 33 21.9706 33 17C33 12.0294 28.9706 8 24 8C19.0294 8 15 12.0294 15 17C15 21.9706 19.0294 26 24 26Z",
    stroke: "#008F47",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/User.606e6eff89def1b2f016631299e5b2b5.svg";
export { ForwardRef as ReactComponent };